import React, { Component } from "react";
import { compose } from "redux";
import { Row, Col } from "react-flexbox-grid";
import { connect } from "react-redux";
import Textfield from "../../signup/components/Textfield";
import modalStyles from "../styles/syncModal.module.scss";
import { Field, reduxForm } from "redux-form";
import * as Validate from "../../../helpers/validations";
import { X } from "react-feather";

import Datepicker from "../../../components/Datepicker";
import Button from "../../../components/Button";
import moment from "moment";
import { createEvent, deleteEvent } from "../../../actions/events-actions";
import { calendarFunctions } from "../../../helpers/calendar-functions";
import { ToastsStore } from "react-toasts";
import ConfirmationModal from "../../../components/ConfirmationModal";
import { Textarea } from "../../../components/Textarea";

const uuidv4 = require("uuid/v4");

class NoteModal extends Component {
  constructor(props) {
    super(props);
    const { note, isEditing } = props;
    this.state = {
      note: {
        id: isEditing ? note.id : uuidv4(),
        title: isEditing ? note.title : "",
        body: isEditing ? note.body : "",
        calendarId: "liveli",
        category: note.category,
        isAllDay: false,
        start: isEditing ? moment(note.start).clone().toISOString() : moment().clone().toISOString(),
        end: isEditing ? moment(note.end).clone().toISOString() : moment().clone().add(1, "hour").toISOString()
      },
      keys: {
        startDate: uuidv4(),
        untilDate: uuidv4()
      },
      dateFormat: "F j, Y",
      hideUntil: true,
      isEditing,
      editionEnabled: false,
      showConfirmDeleteModal: false,
      noteChanged: false,
      minUntilDate: moment().toISOString(),
      untilDate: moment().toISOString()
    };
    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount() {
    this.initializeDatePickers();

    if (this.props.isEditing) {
      const { note } = this.props;
      this.props.initialize({
        title: note.title,
        body: note.body
      });
    }
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount(){
      document.removeEventListener("keydown", this.escFunction, false);
  }
  escFunction(event) {
    if (event.keyCode === 27) {
        if(!this.state.showConfirmDeleteModal) {
            this.props.onClose();
        }
    }
}
  componentDidUpdate(prevProps) {
    if (
      prevProps.saving &&
      !this.props.saving &&
      this.props.updateEventsSuccess
    ) {
      this.props.onClose();
      ToastsStore.success(
        this.props.isEditing ? "Note Updated" : "Note Created"
      );
    }

    if (
      !this.props.deleting &&
      prevProps.deleting &&
      this.props.deleteEventsSuccess
    ) {
      this.props.onClose();
      ToastsStore.success("Note Deleted");
    }
  }

  initializeDatePickers = () => {
    const { note } = this.props;

    const start = moment(note.start.toDate());
    const end = moment(note.end.toDate())
      .clone()
      .set({ hour: 23, minute: 59, seconds: 59 })
      .toISOString();

    this.setState(state => {
      return {
        note: {
          ...state.note,
          start: start.toISOString(),
          end
        }
      };
    });
  };

  toggleEdition = () => {
    this.setState({
      editionEnabled: !this.state.editionEnabled,
      keys: {
        ...this.state.keys,
        startDate: uuidv4()
      }
    });
  };

  onDelete = () => this.setState({ showConfirmDeleteModal: true });

  closeNoteDeletionModal = () =>
    this.setState({ showConfirmDeleteModal: false });

  onChangeNoteAttribute = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState(state => {
      return {
        note: {
          ...state.note,
          [name]: value
        },
        noteChanged: true
      };
    });
  };

  updateNoteDate = dateString => {
    const startDate = moment(dateString)
      .clone()
      .set({ hour: 0, minute: 0, second: 0 });
    this.setState(state => {
      return {
        note: {
          ...state.note,
          start: startDate.toISOString(),
          end: startDate
            .clone()
            .set({ hour: 23, minute: 59, seconds: 59 })
            .toISOString()
        },
        noteChanged: true
      };
    });
  };

  deleteSingleNote = () => {
    const { note } = this.props;
    const sortKey = moment(note.start.toDate()).format("YYYY-MM");
    const newEvents = calendarFunctions.removeEvent(this.props.events, note);

    const data = {
      email: this.props.user.email,
      sortKey,
      events: calendarFunctions.removeCalendarProps(newEvents),
      create: false
    };

    this.props.deleteNote(data);
  };

  onSubmit = () => {
    const { note } = this.state;
    let newNote = note;

    let sortKey,
      newEvents = [];

      sortKey = moment(newNote.start).format("YYYY-MM");

      if (this.props.isEditing) {
        let previousSortKey = moment(this.props.note.start.toDate()).format(
          "YYYY-MM"
        );

        /* If event changed his date it will be inserted as new in another SortKey */
        if (previousSortKey !== sortKey) {
          // Remove event from original sortKey Events
          const eventsWithoutUpdated = calendarFunctions.removeEvent(
            this.props.events,
            newNote
          );
          this.executeUpdate(previousSortKey, eventsWithoutUpdated, false);

          // Create event in new SortKey
          this.executeUpdate(sortKey, [newNote], true);
          return;
        } else {
          newEvents = calendarFunctions.putUpdatedEvent(
            this.props.events,
            newNote
          );
        }
      } else {
        newEvents.push(newNote);
      }

    this.executeUpdate(sortKey, newEvents, this.props.isEditing ? false : true);
  };

  executeUpdate = (sortKey, events, create) => {
    const data = {
      email: this.props.user.email,
      sortKey,
      events: calendarFunctions.removeCalendarProps(events),
      create: create,
      viewSortKey: moment(this.props.note.start.toDate()).format("YYYY-MM")
    };

    this.props.putNotes(data);
  };

  isSubmitButtonDisabled = () => {
    const { noteChanged, isEditing, editionEnabled } = this.state;
    const { invalid, submitting } = this.props;
    const invalidForm = (invalid || submitting);

    if (invalidForm) {
      return true;
    } else if (isEditing && !editionEnabled && !noteChanged) {
      return false;
    } else if (!isEditing && !invalidForm) {
      return false;
    } else if (isEditing && noteChanged) {
      return false;
    } else {
      return true;
    }
  };

  renderFooterButtons = () => {
    const { isEditing, editionEnabled } = this.state;
    let firstBtnLabel = "Cancel",
      secondBtnLabel = "Save",
      onClickFirstBtn = this.props.onClose,
      isDeleteSecondBtn = false,
      isLoginSecondBtn = true;

    if (isEditing && editionEnabled) {
      firstBtnLabel = "Cancel";
      secondBtnLabel = "Update";
      onClickFirstBtn = this.toggleEdition;
      isDeleteSecondBtn = false;
      isLoginSecondBtn = true;
    } else if (isEditing) {
      firstBtnLabel = "Edit";
      secondBtnLabel = "Delete";
      onClickFirstBtn = this.toggleEdition;
      isDeleteSecondBtn = true;
      isLoginSecondBtn = false;
    }

    return (
      <Row end="xs" style={{ paddingTop: 16 }}>
        <Col xs={4}>
          <Button label={firstBtnLabel} cancel={true} click={onClickFirstBtn} />
        </Col>
        <Col xs={4}>
          <Button
            disabled={this.isSubmitButtonDisabled()}
            type="submit"
            delete={isDeleteSecondBtn}
            login={isLoginSecondBtn}
            label={secondBtnLabel}
          />
        </Col>
      </Row>
    );
  };

  render() {
    const { note, isEditing, editionEnabled } = this.state;
    const { handleSubmit } = this.props;
    const enableFields = isEditing === false || (isEditing && editionEnabled);

    return (
      <section
        className={[
          modalStyles.alertPrompt__background,
          modalStyles.__active
        ].join(" ")}
      >
        {this.state.showConfirmDeleteModal && (
          <ConfirmationModal
            title="Delete Note"
            label="Confirm note deletion?"
            confirmText="Delete"
            cancelText="Cancel"
            onClose={this.closeNoteDeletionModal}
            onConfirm={this.deleteSingleNote}
          />
        )}
        <section
          className={modalStyles.alertPrompt__card}
        >
          <header className={modalStyles.alertPrompt__header}>
            <Row start="xs" between="xs">
              <Col xs={12}>
                <h4>{isEditing ? "Edit Note" : "Create Note"}</h4>
                <span
                  className={modalStyles.alertPrompt__close}
                  onClick={this.props.onClose}
                >
                  <X size={24} color="#C61C33" />
                </span>
              </Col>
            </Row>
          </header>
          <section className={modalStyles.alertPrompt__form}>
            <Row center="xs">
              <Col xs={12}>
                <form
                  onSubmit={handleSubmit(
                    isEditing
                      ? editionEnabled
                        ? this.onSubmit
                        : this.onDelete
                      : this.onSubmit
                  )}
                >
                  <Field
                    onChange={this.onChangeNoteAttribute}
                    name="title"
                    label="title"
                    props={{
                      input_type: "text",
                      label: "Title",
                      disabled: !enableFields
                    }}
                    component={Textfield}
                    validate={[Validate.required]}
                  />
                  <Row
                    start="xs"
                    className={modalStyles.row}
                    style={{ paddingTop: 16 }}
                  >
                    <Col xs={6}>
                      <Datepicker
                        label="Date"
                        defaultValue={note.start}
                        value={note.start}
                        enableTime={false}
                        altFormat={this.state.dateFormat}
                        onChange={this.updateNoteDate}
                        disabled={!enableFields}
                        key={this.state.keys.startDate}
                      />
                    </Col>
                  </Row>
                  <Field
                    onChange={this.onChangeNoteAttribute}
                    name="body"
                    label="description"
                    props={{
                      label: "Note Description",
                      disabled: !enableFields,
                      name: "body"
                    }}
                    component={Textarea}
                  />
                  {this.renderFooterButtons()}
                </form>
              </Col>
            </Row>
          </section>
        </section>
      </section>
    );
  }
}

const form = reduxForm({
  form: "noteForm"
});

const mapStateToProps = state => {
  return {
    user: state.userReducer.user,
    events: state.eventsReducer.events,
    recurrentEvents: state.eventsReducer.recurrentEvents,
    errorType: state.eventsReducer.errorStatus,
    updateEventsSuccess: state.eventsReducer.updateEventsSuccess,
    updateEventsError: state.eventsReducer.updateEventsError,
    deleteEventsSuccess: state.eventsReducer.deleteEventsSuccess,
    errorMessage: state.eventsReducer.errorMessage,
    deleting: state.eventsReducer.deleting,
    saving: state.eventsReducer.saving,
    loading: state.eventsReducer.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    putNotes: data => dispatch(createEvent(data)),
    deleteNote: data => dispatch(deleteEvent(data))
  };
};

export default compose(
  form,
  connect(mapStateToProps, mapDispatchToProps)
)(NoteModal);
